<template>
  <div class="midProjectEvaluation">
    <div class="top">
      <div class="title" v-if="detailData">{{ detailData.unitName }}</div>
      <div class="time" v-if="detailData">
        <span>签约时间</span>
        {{ detailData.time }}
      </div>
    </div>
    <div class="middle" v-if="detailData">
      <div class="title">项目名称</div>
      <div class="name">{{ detailData.projectName }}</div>
      <div class="title">项目介绍</div>
      <div class="name">{{ detailData.intro }}</div>
    </div>

    <div class="bottom">
      <div class="title">请打分</div>
      <ul class="appraiseList">
        <li v-for="(item, index) in appraiseList" :key="index" :class="{ active: index === isActive }"
            @click="choseAppraise(index, item)">{{ item.title }}
        </li>
      </ul>
    </div>

    <div class="bottom-btn">
      <van-button color="#096CEFFF" round @click="submitEvaluation" block>提交中期评价</van-button>
    </div>
  </div>
</template>

<script>
import { appraiseList } from '@/libs/enumerates'
import { midAssess, midAssessProjectInfo } from '@api/news'

export default {
  name: 'midProjectEvaluation',
  data () {
    return {
      appraiseList: appraiseList,
      isActive: '',
      detailData: {},
      grade: '' // 选择的评分
    }
  },
  created () {
    this.midAssessProjectInfo()
  },
  methods: {
    midAssessProjectInfo () {
      midAssessProjectInfo({
        projectId: this.$route.query.projectId,
        unitId: this.$route.query.unitId
      }).then(res => {
        if (res.data.code === 200) {
          this.detailData = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 评分
    choseAppraise (index, item) {
      this.isActive = index
      this.grade = item.name
    },

    // 提交评价
    submitEvaluation () {
      if (!this.grade) {
        this.$toastMsg('请先进行打分')
        return false
      }
      midAssess({
        projectId: this.$route.query.projectId,
        unitId: this.$route.query.unitId,
        grade: this.grade
      }).then(res => {
        if (res.data.code === 200) {
          this.$toast.success('提交成功')
          setTimeout(() => {
            this.$bridge.callHandler('backRefresh', response => {
              console.log('response:', response)
            })
          }, 1000)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.midProjectEvaluation {
  color: #333;
  padding-bottom: 80px;

  .top {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.02);
    background: #FFFFFF;
    padding: 15px;
    margin-bottom: 15px;

    .title {
      @include add_size($font_size_24);
      font-weight: bold;
      margin-bottom: 8px;
    }

    .time {
      @include add_size($font_size_20);

      span {
        color: #999;
      }
    }
  }

  .middle {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.02);
    background: #FFFFFF;
    padding: 15px;
    margin-bottom: 15px;

    .title {
      @include add_size($font_size_20);
      color: #333;
      font-weight: bold;
      margin-bottom: 4px;
    }

    .name {
      @include add_size($font_size_20);
      color: #333;
      margin-bottom: 8px;
    }
  }

  .bottom {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.02);
    background: #FFFFFF;
    padding: 15px;

    .title {
      @include add_size($font_size_20);
      color: #333;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .appraiseList {
      li {
        display: inline-block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 5px;
        background-color: #eeeeee;
        margin-right: 20px;
        @include add_size($font_size_20);

        &:last-child {
          margin-right: 0;
        }
      }

      .active {
        background: #FCB040;
        color: #fff;
      }
    }
  }

}
</style>
